import { render, staticRenderFns } from "./ScholarshipRateSelectbox.vue?vue&type=template&id=b4538b5c"
import script from "./ScholarshipRateSelectbox.vue?vue&type=script&lang=js"
export * from "./ScholarshipRateSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports